import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Segment, Header, Button, Message} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import CounterInput from "react-counter-input";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// import { Segment, Tab } from 'semantic-ui-react'
import qs from 'query-string';
import _ from 'underscore';
import ProductView from '../../component/marketplace/product_view';
import {productsRedeemAction} from '../../actions/productsActions'
import moment from 'moment';

import QrReader from 'react-qr-reader'
import {
    getMHCYoutubeVideosDetail,
} from '../../actions';

//QR code
export const QR_CODE_REDEEM_AMARA = 'f040d5d0d2a53d6230ce45d3e01898a98c0f67f4ce826531aff7d36f16d5b11d'; //sha-256

class ProductRedeemPage extends Component {
    state = {
        type: null,
        id: null,
        errorMessage: null
    }
    componentDidMount() {
        // this.props.getMHCArticlesFullList();
        // this.props.getMHCYoutubeVideosFullList();
        const { search } = this.props.location;
        const parsedQueryString = qs.parse(search);
        const {
            id, type
        } = parsedQueryString;
        console.log( id, "SEARCH")
        this.setState({id, type});
        this.setState({quantity: 0})
        this.setState({qr: false})
    }

    handleScan = data => {
        if (data) {
            if (data !== QR_CODE_REDEEM_AMARA) {
                this.setState({
                    errorMessage: 'Wrong QR code, please make sure you scan the correct QR code.'
                });
            }
            else {
                this._redeemHandler(data)
                this.setState({
                    errorMessage: null,
                    qr: false
                });
            }
        }
    }

    handleError = err => {
      console.error(err)
    }

    render() {
        console.log(this.props.products)
        console.log(this.state.id)
            var purchasedProduct = this.props.products.purchasedProducts.find((purchasedProduct) => purchasedProduct.uuid == this.state.id)
            if(purchasedProduct){
            return (
                // <div></div>
                    <div>
                    { this.state.qr ? 
                    <div style={{ }}>
                      <QrReader
                        delay={300}
                        onError={this.handleError}
                        onScan={this.handleScan}
                        style={{ width: '30%', "margin-left": "auto", "margin-right": "auto" }}
                      />
                      <p>{this.state.result}</p>
                        <Button attached
                            onClick={() => this.setState({qr: false})}>
                            Cancel
                        </Button>
                        { this.state.errorMessage &&
                            <Message negative>
                                { this.state.errorMessage }
                            </Message> }
                    </div>
                    :
                    <div>
                    <Header as='h2' attached='top' block>
                        View product
                    </Header>
                    <Link to="/app/store">
                        <Button attached>
                            Go back to store
                        </Button>
                    </Link>
                    <Segment attached>
                        <iframe 
                            src={purchasedProduct.product.url} 
                            width="100%"
                            height="850"
                            frameBorder="0"
                        />
                    </Segment>
                    { this.props.products.error &&
                        <Message negative>
                            { this.props.products.error.message }
                        </Message> }
                    <div>
                        <p style={{"text-align": "center"}}>
                            { 'Quantity: ' + purchasedProduct.quantity }
                        </p>
                        <p style={{"text-align": "center"}}>
                            { 'Purchased on ' + moment(purchasedProduct.created).format('DD MMM YYYY h:mm A') }
                        </p>
                    </div>
                    { purchasedProduct.redeemedDate &&
                        <Button attached>
                        { 'Redeemed on ' + moment(purchasedProduct.redeemedDate).format('DD MMM YYYY h:mm A') }
                        </Button>
                    }
                    <div style={{
                        "flex-direction": "row"
                    }}>
                        <Link to={`/app/product/invoice?uuid=${purchasedProduct.uuid}?userUUID=${purchasedProduct.userUUID}?invoiceId=${purchasedProduct.invoiceId}`}>
                        <Button  
                            style={{ 
                                "margin-bottom":"5px"
                            }}
                            type="submit"
                            primary
                            disabled={this.props.products.loading}
                            fluid
                            size="medium"  
                            >
                            View Invoice
                        </Button>
                         </Link>
                        { !purchasedProduct.redeemedDate &&
                        <Button 
                            loading={this.props.products.loading}
                            type="submit"
                            primary
                            disabled={this.props.products.loading}
                            fluid
                            size="medium" 
                            onClick={() => this.redeemNow()}>
                            Scan to Redeem
                        </Button>
                    }
                    </div>
                    
                </div>
                }
                </div>
            );
        }
        return(<div></div>)
    }

    redeemNow(){
        confirmAlert({
            title: '',
            message: 'You are about to redeem this voucher. Upon successful scanning of the QR code, this voucher will be considered used.',
            buttons: [
            {
                label: 'Cancel',
                onClick: () => {}
            },
            {
                label: 'OK',
                onClick: () => {
                    this.setState({qr: true})
                }
            }
            ]
        });
    };

    _redeemHandler(data) {
        this.props.productsRedeemAction(this.state.id, data).then(() => {

            const {error} = this.props.products;

            if (error) {
                return
            }

            window.alert("Redeem successful!");
        });
    }

}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        products: state.products,
        stripe: state.stripe
    }
}

export default connect(mapStateToProps, {
    productsRedeemAction
})(ProductRedeemPage);